export const condenseNumberToShortFormat = (
  inputNumber: number = 0,
): string => {
  const absValue = Math.abs(inputNumber)

  if (absValue >= 1.0e9) {
    return roundOffToFixedDecimals({value: absValue / 1.0e9}) + 'B'
  }
  if (absValue >= 1.0e6) {
    return roundOffToFixedDecimals({value: absValue / 1.0e6}) + 'M'
  }
  if (absValue >= 1.0e5) {
    return roundOffToFixedDecimals({value: absValue / 1.0e3}) + 'K'
  }
  return absValue.toLocaleString()
}

export const roundOffToFixedDecimals = ({
  value,
  decimals = 0,
}: {
  value: number
  decimals?: number
}): string => {
  return value.toFixed(decimals)
}
